import { bootstrapAdminCsrfToken, resolveCsrfHeaderForMethod } from '../../../lib/api/csrfToken'
import type { SetupValidationSummary, SetupCompletionPayload } from '../../../types'
import { API_BASE } from '../constants'
import type { Translator } from './types'
import { sanitizeSetupErrorMessage } from './errors'
import { normalizeValidationSummary, readResponsePayload, toResponseError } from './payloads'
import { requestSetupApi } from './request'

export const requestSetupValidation = async ({
  payload,
  t,
}: {
  payload: SetupCompletionPayload
  t: Translator
}): Promise<SetupValidationSummary> => {
  await bootstrapAdminCsrfToken(API_BASE)
  const response = await requestSetupApi({
    path: '/setup/validate',
    fallbackError: t('setup.toast.completeError'),
    init: {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...resolveCsrfHeaderForMethod('POST'),
      },
      body: JSON.stringify(payload),
    },
  })

  const { raw, data } = await readResponsePayload(response)
  if (!response.ok) {
    const message = toResponseError({
      raw,
      data,
      fallback: t('setup.toast.statusError', { status: response.status }),
    })
    throw new Error(sanitizeSetupErrorMessage({ message, t }))
  }

  return normalizeValidationSummary(data?.validation) ?? { status: 'warning', checks: [] }
}
